export const commonInArticleConfig = {};
